import { deploymentsApi } from '../api/deploymentsApi';
import { deploymentQueryKey } from './useDeployment';
import {
  useDeploymentMutation,
  type DeploymentMutationOptions,
} from './_deploymentMutations';

interface RetryResult {
  jobId: string;
  deploymentId: string;
}

/** Retries a single failed item when an itemId is given, otherwise every failed item. */
export const useRetryDeploymentItem = (
  deploymentId: string,
  options: DeploymentMutationOptions<RetryResult> = {}
) =>
  useDeploymentMutation<number | undefined, RetryResult>({
    mutationFn: (itemId) =>
      itemId != null
        ? deploymentsApi.retryItem(deploymentId, itemId)
        : deploymentsApi.retryFailed(deploymentId),
    invalidate: (qc) => {
      qc.invalidateQueries({ queryKey: deploymentQueryKey(deploymentId) });
      qc.invalidateQueries({ queryKey: ['deployments'] });
    },
    errorLabel: 'Error retrying deployment item',
    ...options,
  });
